import React, {useState} from 'react';
import SearchIcon from '@material-ui/icons/Search';
import clsx from "clsx";
import {makeStyles} from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import './search.scss'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent:'flex-end'
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: '25ch',
  },
}));

function SearchBar(props) {

  const classes = useStyles();


  const {value,placeholder,  inputStyle,} = props;
  return (
    <div className={classes.root}>
    <TextField
      variant='outlined'
      margin='dense'
      placeholder={placeholder}
      className={clsx(classes.margin, classes.textField)}
      value={value}
      InputProps={{
        startAdornment: <InputAdornment position="start"><SearchIcon/></InputAdornment>,
      }}
      onChange={(e) => props.onChange( e.target.value)}
    />
    </div>
  );
}

export default SearchBar;

